export * from './chatContextTypes';

export enum MessageRoles {
  USER = 'user',
  ASSISTANT = 'assistant',
  LEGAL = 'legal',
  USER_INVALID = 'user_invalid_message',
  AUTO_MESSAGE = 'auto-message',
}
